import request from '@/utilsCloud/request'
import port from './port'


// 获取单位系统课程当前配置
export function getUserCourseStudyDetailFromSingleCourse(query) {
  return request({
    url: port.course + '/home/getUserCourseStudyDetailFromSingleCourse',
    headers: {
      isToken: true,
      isEntpId: true
    },
    method: 'get',
    params: query
  })
}

// 获取单位系统课程当前配置
export function saveUserStudyTime(data) {
  return request({
    url: port.course + '/home/saveUserStudyTime',
    headers: {
      isToken: true,
      isEntpId: true
    },
    method: 'post',
    data: data
  })
}


// 获取单位系统课程当前配置
export function getEnterpriseWebsite(query) {
  return request({
    url: port.biz + '/enterprise/getEnterpriseWebsite',
    headers: {
      isToken: true,
      isEntpId: true
    },
    method: 'get',
    params: query
  })
}



// WEBPACK FOOTER //
// ./src/apiCloud/coursePlayByPrivate.js